/**
 * ثبت خودکار permissions از پاسخ API بر اساس URL
 */
import { splitApiPermissions } from './permissions';

/** اولین سگمنت API بعد از /api/v1/ */
const API_RESOURCE_PATTERNS = [
  { pattern: /^tickets/i, resource: 'tickets' },
  { pattern: /^ticket-/i, resource: 'tickets' },
  { pattern: /^leads/i, resource: 'leads' },
  { pattern: /^lead-contact/i, resource: 'leads' },
  { pattern: /^lead-/i, resource: 'leads' },
  { pattern: /^kanban-board/i, resource: 'leads' },
  { pattern: /^deals/i, resource: 'leads' },
  { pattern: /^clients/i, resource: 'clients' },
  { pattern: /^client-/i, resource: 'clients' },
  { pattern: /^products/i, resource: 'products' },
  { pattern: /^product-/i, resource: 'products' },
  { pattern: /^orders/i, resource: 'orders' },
  { pattern: /^notices/i, resource: 'notices' },
  { pattern: /^messages/i, resource: 'messages' },
  { pattern: /^employees/i, resource: 'employees' },
  { pattern: /^employee-/i, resource: 'employees' },
  { pattern: /^leaves/i, resource: 'leaves' },
  { pattern: /^leave-/i, resource: 'leaves' },
  { pattern: /^attendance/i, resource: 'attendance' },
  { pattern: /^holidays/i, resource: 'holidays' },
  { pattern: /^holiday/i, resource: 'holidays' },
  { pattern: /^departments/i, resource: 'employees' },
  { pattern: /^designations/i, resource: 'employees' },
  { pattern: /^shift/i, resource: 'shift' },
  { pattern: /^employee-shifts/i, resource: 'shift' },
  { pattern: /^invoices/i, resource: 'invoices' },
  { pattern: /^invoice-/i, resource: 'invoices' },
  { pattern: /^estimates/i, resource: 'estimates' },
  { pattern: /^estimate/i, resource: 'estimates' },
  { pattern: /^expenses/i, resource: 'expenses' },
  { pattern: /^expense/i, resource: 'expenses' },
  { pattern: /^recurring-expenses/i, resource: 'expenses' },
  { pattern: /^bank-accounts/i, resource: 'bankaccount' },
  { pattern: /^bankaccount/i, resource: 'bankaccount' },
  { pattern: /^payments/i, resource: 'payments' },
  { pattern: /^my-calendar/i, resource: 'events' },
  { pattern: /^events/i, resource: 'events' },
  { pattern: /^calendar/i, resource: 'events' },
  { pattern: /^reports/i, resource: 'reports' },
  { pattern: /^contracts/i, resource: 'contracts' },
  { pattern: /^contract-/i, resource: 'contracts' },
  { pattern: /^projects/i, resource: 'projects' },
  { pattern: /^project-/i, resource: 'projects' },
  { pattern: /^taskboards/i, resource: 'tasks' },
  { pattern: /^tasks/i, resource: 'tasks' },
  { pattern: /^task-/i, resource: 'tasks' },
  { pattern: /^sub-tasks/i, resource: 'tasks' },
  { pattern: /^timelogs/i, resource: 'tasks' },
  { pattern: /^time-logs/i, resource: 'tasks' },
  { pattern: /^call-center/i, resource: 'callcenter' },
  { pattern: /^callcenter/i, resource: 'callcenter' },
  { pattern: /^simotel/i, resource: 'callcenter' },
  { pattern: /^livechat/i, resource: 'livechat' },
];

let registerFn = null;

export const setApiPermissionRegistrar = (fn) => {
  registerFn = fn;
};

export const inferResourceFromApiUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  try {
    const path = url.includes('://') ? new URL(url).pathname : url;
    const match = path.match(/\/api\/v\d+\/([^/?#]+)/i);
    const segment = match?.[1] || '';
    if (!segment) return null;
    const hit = API_RESOURCE_PATTERNS.find(({ pattern }) => pattern.test(segment));
    return hit?.resource ?? null;
  } catch {
    return null;
  }
};

/** پردازش JSON و ثبت permissions؛ همان payload برمی‌گردد */
const extractPermissionsDeep = (payload) => {
  if (!payload || typeof payload !== 'object') return { body: payload, permissions: null };

  const top = splitApiPermissions(payload);
  if (top.permissions) return top;

  if (payload.data && typeof payload.data === 'object' && 'permissions' in payload.data) {
    const nested = splitApiPermissions(payload.data);
    return {
      body: { ...payload, data: nested.body },
      permissions: nested.permissions,
    };
  }

  return top;
};

export const processApiResponseWithPermissions = (url, payload) => {
  if (!payload || typeof payload !== 'object') return payload;

  const { body, permissions } = extractPermissionsDeep(payload);
  const resource = inferResourceFromApiUrl(url);

  if (resource && permissions && registerFn) {
    registerFn(resource, permissions);
  }

  const result = body ?? payload;
  // permissions برای صفحات جزئیات (مثل ViewLead) در state محلی لازم است
  if (permissions && result && typeof result === 'object' && !Array.isArray(result)) {
    return { ...result, permissions };
  }

  return result;
};
